package fr.labodoc.healthProfessional.api.payloads.requests

import fr.labodoc.domain.labodoc.common.NotificationFrequency
import kotlinx.serialization.Serializable

@Serializable
data class UpdateSelfNotificationsSettingsRequest(
  val notificationFrequency: NotificationFrequency?
)
